
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { 
  TrendingUp, 
  Hash, 
  Users,
  UserPlus
} from "lucide-react";

// Mock data - in a real app, this would come from an API
const topTags = [
  { id: 1, name: "manga", count: 1245 },
  { id: 2, name: "anime", count: 987 },
  { id: 3, name: "webtoon", count: 765 },
  { id: 4, name: "fanart", count: 543 },
  { id: 5, name: "cosplay", count: 432 }
];

const trendingTopics = [
  { id: 1, title: "Novo lançamento de One Piece", posts: 324 },
  { id: 2, title: "Debate: melhor anime de 2023", posts: 256 },
  { id: 3, title: "Fan theories sobre Attack on Titan", posts: 198 },
  { id: 4, title: "Concurso de fanart digital", posts: 167 }
];

const suggestedUsers = [
  { id: 1, username: "animefan88", avatar: "https://github.com/shadcn.png", followers: 12.5 },
  { id: 2, username: "mangamaster", avatar: "https://github.com/shadcn.png", followers: 8.3 },
  { id: 3, username: "artcreator", avatar: "https://github.com/shadcn.png", followers: 5.7 }
];

export const PostsSidebar = () => {
  return (
    <div className="w-full space-y-6 animate-fade-in">
      {/* Popular Tags */}
      <Card className="p-4">
        <div className="flex items-center gap-2 mb-4">
          <Hash className="h-5 w-5 text-primary" />
          <h3 className="font-semibold">Tags Populares</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {topTags.map(tag => (
            <Badge key={tag.id} variant="secondary" className="hover-scale cursor-pointer">
              #{tag.name}
              <span className="ml-1 text-xs text-muted-foreground">({tag.count})</span>
            </Badge>
          ))}
        </div>
      </Card>

      {/* Trending Now */}
      <Card className="p-4">
        <div className="flex items-center gap-2 mb-4">
          <TrendingUp className="h-5 w-5 text-primary" />
          <h3 className="font-semibold">O Que Está Acontecendo</h3>
        </div>
        <div className="space-y-3">
          {trendingTopics.map(topic => (
            <div key={topic.id} className="group">
              <h4 className="text-sm font-medium group-hover:text-primary transition-colors cursor-pointer">{topic.title}</h4>
              <p className="text-xs text-muted-foreground">{topic.posts} posts</p>
              <Separator className="mt-2" />
            </div>
          ))}
        </div>
      </Card>

      {/* Who to Follow */}
      <Card className="p-4">
        <div className="flex items-center gap-2 mb-4">
          <Users className="h-5 w-5 text-primary" />
          <h3 className="font-semibold">Quem Seguir</h3>
        </div>
        <div className="space-y-4">
          {suggestedUsers.map(user => (
            <div key={user.id} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Avatar className="h-8 w-8 border border-gray-200 dark:border-primary/20">
                  <AvatarImage src={user.avatar} />
                  <AvatarFallback>{user.username.charAt(0).toUpperCase()}</AvatarFallback>
                </Avatar>
                <div>
                  <h4 className="text-sm font-medium">{user.username}</h4>
                  <p className="text-xs text-muted-foreground">{user.followers}k seguidores</p>
                </div>
              </div>
              <Button size="sm" variant="outline" className="gap-1">
                <UserPlus className="h-3.5 w-3.5" />
                <span className="text-xs">Seguir</span>
              </Button>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};
